import { useDocumentTitle } from '../hooks/useDocumentTitle';
import HeroSection from '../components/sections/HeroSection';
import OverviewSection from '../components/sections/OverviewSection';
import StatsBand from '../components/sections/StatsBand';
import IndustriesSection from '../components/sections/IndustriesSection';
import WhyChooseSection from '../components/sections/WhyChooseSection';
import CtaSection from '../components/sections/CtaSection';

const HomePage = () => {
  useDocumentTitle(
    undefined,
    'NEAT Systems — Building Smarter IT Infrastructure. Enterprise-grade computing and networking solutions from HP, Dell, Lenovo, Supermicro, Cisco, Arista, and Juniper.'
  );

  return (
    <>
      <HeroSection />
      <OverviewSection />
      <StatsBand />
      <IndustriesSection />
      <WhyChooseSection />
      <CtaSection />
    </>
  );
};

export default HomePage;
